import "./css/App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import LayoutDefault from "./layouts/LayoutDefault";
import LayoutCTA from "./layouts/LayoutCTA";
import Landing from "./views/Landing";
import Users from "./views/Users";
import Legal from "./views/Legal";
import Error404 from "./views/Error404";

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/">
            <LayoutCTA>
              <Landing />
            </LayoutCTA>
          </Route>
          <Route exact path="/user/:id">
            <LayoutCTA>
              <Users />
            </LayoutCTA>
          </Route>
          <Route exact path="/legal/:id">
            <LayoutDefault>
              <Legal />
            </LayoutDefault>
          </Route>
          <Route path="*">
            <LayoutDefault>
              <Error404 />
            </LayoutDefault>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
